var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44009 10.5301L21.6101 2.66006C21.8001 2.59006 22.0201 2.57006 22.2101 2.62006C22.7701 2.75006 23.1301 3.31006 23.0001 3.87006L19.5201 20.3101C19.4901 20.4601 19.4201 20.6001 19.3301 20.7301C18.9801 21.2101 18.3001 21.3201 17.8201 20.9601L12.6201 17.1401L9.97009 19.8501C9.87009 19.9501 9.74009 20.0301 9.61009 20.0701C9.14009 20.2201 8.65009 19.9601 8.50009 19.5001L6.62009 13.4301L1.50009 11.9201C1.28009 11.8601 1.10009 11.6901 1.01009 11.4701C0.870092 11.0901 1.06009 10.6701 1.44009 10.5301ZM9.65009 14.6101L19.0501 6.32006C19.0901 6.26006 19.1101 6.18006 19.0801 6.11006C19.0401 5.98006 18.9101 5.90006 18.7801 5.93006L7.76009 12.7901C7.55009 12.8901 7.44009 13.1301 7.51009 13.3601L8.92009 18.1301C8.93009 18.1601 8.96009 18.1901 8.99009 18.2001C9.05009 18.2201 9.10009 18.1901 9.12009 18.1301L9.48009 14.9301C9.50009 14.8101 9.56009 14.6901 9.65009 14.6101Z",
    fill: "#009BE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/TelegramIcon.1651a205ed10e90bc68ace88071dfae4.svg";
export { ForwardRef as ReactComponent };